import React, { Component } from 'react';
import { connect } from 'react-redux';
import Pagination from 'rc-pagination';
import {bounceEmailList, deleteBounceEmail} from '../../../api'
import windowModal from '../../../component/Modal';

@connect(
  state=>state.tenant,
  null
)
export default class BounceEmails extends Component{
  constructor(props) {
    super(props);
    this.state = {
      dataRows: [],
      totalRows: 0,
      pageSize: 10,
      currentPage: 1,
      email: '',
      startTime: '',
      endTime: '',
    };
  }
  componentDidMount() {
    this.mounted = true;
    windowModal();
    this._eventHandler();
    let body = {
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getList(body);
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  _eventHandler = () => {
    $('#finishdate').datepicker({
      dateFormat : 'mm/dd/yy',
      prevText : '<i class="fa fa-chevron-left"></i>',
      nextText : '<i class="fa fa-chevron-right"></i>'
    });
    $('#startdate').datepicker({
      dateFormat : 'mm/dd/yy',
      prevText : '<i class="fa fa-chevron-left"></i>',
      nextText : '<i class="fa fa-chevron-right"></i>'
    });
  };
  _getList = body => {
    if (this.props.loginAdmin === "isos") body.tenantName = this.props.tenantInfo.name;
    else body.tenantName = this.props.loginAdmin;
    this.setState({
      email: body.email || '',
      startTime: body.startTime || '',
      endTime: body.endTime || ''
    });
    bounceEmailList(body)
      .then(res=>{
        let data = res.data || {};
        if (this.mounted) {
          this.setState({
            dataRows: data.list,
            totalRows: data.totalRows,
            currentPage: data.currentPage
          });
        }
      })
      .catch(err=>{
        console.log(err);
      });
  };
  _resetAll = () => {
    $("#searchBounceEmail").find("input").val("");
  };
  _searchHandler = () => {
    let search_email = $("#search-email").val().trim();
    let search_startdate = $("#startdate").val();
    let search_finishdate = $("#finishdate").val();

    let body = {
      email: search_email,
      startTime: search_startdate,
      endTime: search_finishdate,
      currentPage: 1,
      pageSize: this.state.pageSize
    };
    this._getList(body);
  };
  _confirmDelete = e => {
    let that = this;
    let id = e.target.id;
    Modal.confirm({
      msg: "Are you sure you want to remove this email address from the bounce list?"
    }).on(function (data) {
      if (data === true) {
        let body = {
          email: id
        };
        if (that.props.loginAdmin === "isos") body.tenantName = that.props.tenantInfo.name;
        else body.tenantName = that.props.loginAdmin;
        that._deleteBounceEmail(body);
      }
    });
  };
  _deleteBounceEmail = body => {
    deleteBounceEmail(body)
      .then(res => {
        $.sound_on = false;
        $.smallBox({
          title : "Alert",
          content : "Email address successfully removed!",
          color : "#296191",
          iconSmall : "fa fa-thumbs-up bounce animated",
          timeout : 2000
        });
        let search_email = $("#search-email").val().trim();
        let search_startdate = $("#startdate").val();
        let search_finishdate = $("#finishdate").val();
        let body = {
          email: search_email,
          startTime: search_startdate,
          endTime: search_finishdate,
          currentPage: this.state.currentPage,
          pageSize: this.state.pageSize
        };
        this._getList(body);
      })
      .catch(err=>console.log(err))
  };
  _onChange = page => {
    let search_email = $("#search-email").val().trim();
    let search_startdate = $("#startdate").val();
    let search_finishdate = $("#finishdate").val();
    let body = {
      email: search_email,
      startTime: search_startdate,
      endTime: search_finishdate,
      currentPage: page,
      pageSize: this.state.pageSize
    };
    if (this.mounted) {
      this.setState({currentPage: page});
    }
    this._getList(body);
  };
  _formateDate = date => {
    let tempDate = new Date(date);
    let month = tempDate.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let day = tempDate.getDate();
    if (day < 10) day = '0' + day;
    return tempDate.getFullYear() + '-' + month + '-' + day;
  };

  render() {
    let { dataRows, totalRows, currentPage, pageSize, email, startTime, endTime } = this.state;
    let { loginAdmin, tenantInfo } = this.props;
    let downloadName = loginAdmin==="isos"?tenantInfo.name:loginAdmin;
    let token = sessionStorage.getItem("token");
    let companyName;
    if (tenantInfo && tenantInfo.companyName) companyName = tenantInfo.companyName;
    return (
      <div>
        <div id="ribbon">
          <ol className="breadcrumb">
            <li>{`${companyName.toUpperCase()} Bounce Email List`}</li>
          </ol>
        </div>
        <div id="content">
          <div className="row">
            <div className="col-xs-12 col-sm-7 col-md-7 col-lg-4">
              <h1 className="page-title txt-color-blueDark">
                <i className="fa fa-table fa-fw " />
                {`${companyName.toUpperCase()} Bounce Email List`}
              </h1>
            </div>
          </div>
          <section id="widget-grid" className="">
            <div className="row">
              <article className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="jarviswidget jarviswidget-color-darken"
                     id="wid-id-0"
                     data-widget-editbutton="false"
                     data-widget-deletebutton="false">
                  <header>
                    <span className="widget-icon">
                      <i className="fa fa-table" />
                    </span>
                    <h2>Bounce Email Center</h2>
                  </header>
                  <div>
                    <div className="jarviswidget-editbox" />
                    <div className="widget-body no-padding">
                      <div className="toolbar clearfix">
                        <form id="searchBounceEmail">
                          <div className="row">
                            <div className="col-md-2 col-lg-1 col-sm-6 search-input">
                              <div className="smart-form-width smart-form client-form ">
                                <label className="input">
                                  <input id="search-email"
                                         name="email"
                                         className="form-control"
                                         type="text"
                                         placeholder="Email"
                                         aria-controls="dt_basic" />
                                  <b className="tooltip tooltip-top-right">
                                    <i className="fa fa-envelope txt-color-teal" /> Search by Email
                                  </b>
                                </label>
                              </div>
                            </div>
                            <div className="col-md-4 col-sm-6">
                              <div className="smart-form mb10">
                                <label className="input" style={{display: 'inline-block'}}>
                                  <i className="icon-append fa fa-calendar"
                                     style={{zIndex: 6}}/>
                                  <input type="text"
                                         placeholder="From"
                                         name="startTime"
                                         id="startdate"
                                         style={{zIndex: 5, position: 'relative'}}
                                         readOnly />
                                </label>&nbsp;
                                <label className="input" style={{display: 'inline-block'}}>
                                  <i className="icon-append fa fa-calendar"
                                     style={{zIndex: 6}}/>
                                  <input type="text"
                                         placeholder="To"
                                         name="endTime"
                                         id="finishdate"
                                         style={{zIndex: 5, position: 'relative'}}
                                         readOnly />
                                </label>
                              </div>
                            </div>
                            <div className="col-md-2 col-sm-6" style={{minWidth: 174}}>
                              <button className="btn btn-primary mb10"
                                      onClick={this._searchHandler}
                                      type="button">
                                <i className="glyphicon glyphicon-search" /> Search
                              </button>
                              <button type="button"
                                      onClick={this._resetAll}
                                      className="btn btn-success search"
                                      style={{margin: '-10px 0 0 3px'}}>
                                Clear
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <table id="subscribTable"
                             className="table table-striped table-bordered table-hover smart-form"
                             width="100%">
                        <thead>
                          <tr>
                            <th>Recipient</th>
                            <th>Date</th>
                            <th>Failure Code</th>
                            <th>Details</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody id="tb">
                        {
                          dataRows.map((row, index) => {
                            return (
                              <tr key={index}>
                                <td>{row.address}</td>
                                <td>{row.created_at ? this._formateDate(row.created_at) : ''}</td>
                                <td>{row.code}</td>
                                <td style={{maxWidth: 280, wordBreak: 'break-all'}}>{row.error}</td>
                                <td className="action">
                                  <a href="javascript:"
                                     id={row.address}
                                     onClick={this._confirmDelete}
                                     className="btn btn-info btn-status">
                                    Remove
                                  </a>
                                </td>
                              </tr>
                            );
                          })
                        }
                        </tbody>
                      </table>
                      <div className="toolbar-bottom">
                        <div className="row">
                          <div className="col-xs-4">
                            <div className='btn-group pull-left'>
                              <a className='btn btn-sm btn-primary'
                                 onClick={()=>location.reload()}
                                 href='javascript:'>
                                <span className='fa fa-refresh' />
                              </a>
                              <a className='btn btn-sm btn-primary'
                                 href={`/api/bounces/downloadLocal?tenantName=${downloadName}&token=${token}&email=${email}&startTime=${startTime}&endTime=${endTime}`} >
                                <span className='fa fa-download' />
                              </a>
                            </div>
                          </div>
                          <div className="col-xs-3">
                            <div className="dataTables_info" aria-live="polite">
                              <span className="text-primary totalRows">{totalRows}</span> entries
                            </div>
                          </div>
                          <div className="col-xs-5">
                            <Pagination
                              className="pull-right"
                              pageSize={pageSize}
                              defaultCurrent={1}
                              onChange={this._onChange}
                              current={currentPage}
                              total={totalRows}
                              showLessItems
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </div>
          </section>
        </div>
        <div id="ycf-alert" className="modal">
          <div className="modal-dialog modal-sm">
            <div className="modal-content"
                 style={{
                   backgroundColor: '#e6e6e6',
                   borderRadius: '7px'
                 }}>
              <div className="modal-header"
                   style={{
                     borderTopRightRadius: '5px',
                     borderTopLeftRadius: '5px'
                   }}>
                <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
                <h5 className="modal-title"><i className="fa fa-exclamation-circle" /> [Title]</h5>
              </div>
              <div className="modal-body small">
                <p>[Message]</p>
              </div>
              <div className="modal-footer" >
                <button type="button" className="btn btn-primary ok" data-dismiss="modal">
                  [BtnOk]
                </button>
                <button type="button" className="btn btn-default cancel" data-dismiss="modal">
                  [BtnCancel]
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container/dashboard/model/bounceEmails.js